import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModeProdService {
  constructor(

  ) {

  }

  ocultar:boolean=true;

  // Piden volver al login tradicional (usuario+contraseña) por defecto sin
  // borrar el flujo OTP: en false, login.component muestra el form clásico
  // con "¿Olvidaste tu contraseña?"; en true, vuelve a mostrarse el login OTP.
  otp_login_enabled:boolean=false;

  ocultar_en_prod(){
    return this.ocultar;
  }


}
